<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
@if (!loading && security.permitted('security', 'roles', 'view')) {
<div class="content-page bg-gray">
    <div class="content p-1 text-dark">
        <div class="px-1 mt-1 text-dark">
            <div class="row d-flex">
                <h5 class="px-1 text-capitalize text-dark"> {{ words[language][ 'security' ] }}</h5>
                <div class="ml-auto">
                    <button class="btn btn-primary btn-sm mr-1" (click)="displayUserRoles($event)">
                        <span class="uil-search-plus mr-1"></span> {{ words[language][ 'manageUserRoles' ] }}
                    </button>
                    <!-- manage user  -->
                    <button [routerLink]="['/settings/users']" class="btn btn-primary btn-sm mr-1">
                        <span class="uil-users-alt mr-1"></span> {{ words[language][ 'viewUsers' ] }}
                    </button>
                </div>
            </div>
            <div class="row">
                <!-- settings panel -->
                <div class="col-md-3 p-1">
                    <div class="rounded p-1">
                        <div class="w-100 d-flex justify-content-left align-items-center pb-0 pt-0 pl-1 border-bottom">
                            <h5>{{ words[language][ 'roles' ] }}<span class="ml-1 uil-question-circle"
                                    title="Create a role such as a salesperson, manager, or collector. A role controls the pages that a user is permitted access to. After creating the role, assign the role to a user or set of users by clicking Manage User Roles at the upper right. For each user, assign the lot that the role is for per user. Any changes made to a role will affect all users assigned to the role."></span>
                            </h5>
                            <button (click)="addRole()" type="button" class="btn btn-sm btn-primary ml-auto"
                                title="Create a new role.">
                                <span class="dripicons-plus text-white"></span>
                            </button>
                        </div>
                        <div class="d-flex flex-column mt-1 role-list">
                            <!-- roles list  -->
                            @for (role of roles; track role) {
                            <div class="d-flex roles rounded">
                                <!-- button role -->
                                <button [ngClass]="{'btn-primary': roleSelected && roleSelected.name==role.name}"
                                    [ngClass]="{'text-dark': !roleSelected}" (click)="selectRole(role)"
                                    class="btn btn-block text-left">
                                    {{role.name}}
                                </button>
                                <!-- settings -->
                                @if (role.name != 'Administrator') {
                                <button class="btn-transparent btn" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false"
                                    [ngClass]="{'text-primary': roleSelected && roleSelected.name==role.name}">
                                    <span class="uil-cog text-dark"></span>
                                    <!-- menu -->
                                    <div class="dropdown-menu text-dark">
                                        <!-- edit -->
                                        @if (security.permitted('security', 'roles', 'update')) {
                                        <a class="dropdown-item pl-2 pr-0" (click)="editRole(role)"><span
                                                class="uil-pen mr-1" title="Edit"></span>
                                            {{ words[language][ 'edit' ]}}
                                        </a>
                                        }
                                        <!-- copy -->
                                        @if (security.permitted('security', 'roles', 'add')) {
                                        <a class="dropdown-item pl-2  pr-0" (click)="copyRole(role)"><span
                                                class="uil-copy mr-1 " title="Copy"></span>
                                            {{ words[language][ 'copy' ]}}
                                        </a>
                                        }
                                        <!-- delete -->
                                        @if (security.permitted('security', 'roles', 'delete')) {
                                        <a class="dropdown-item pl-2  pr-0" (click)="discardRole(role)">
                                            <span class="uil-trash-alt mr-1 text-danger" title="Delete"></span>
                                            {{words[language][ 'delete' ] }}
                                        </a>
                                        }
                                    </div>
                                </button>
                                }
                            </div>
                            }
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <!-- users panel -->
                <div class="col-md-9 p-1">
                    <div class="rounded p-1">
                        <div>
                            @if (!roleSelected && !loading) {
                            <h5>{{ words[language][ 'userRoles' ] }}<span class="uil-question-circle"
                                    title="For each user, assign them a role and the location for that role. To assign a role, click on the + sign next to the username. To assign a location, click on the + sign next to the role."></span>
                            </h5>
                            }
                            @if (roleSelected && (roleSelected.name != '')) {
                            <ul class="nav nav-pills nav-fill">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" data-target="#role-permissions-tab" role="tab">
                                        <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                        <h5
                                            title="Each role has a set of permissions. Those permissions are set at the page, section, and sometimes field level. The 'view' action means to allow users to view the list pages. The 'add' action means to allow users to create a new record. The 'edit' action means to allow users to update information (per section/field). The 'delete' action means to allow users to delete records.">
                                            {{ words[language][ 'rolePermission' ] }}
                                        </h5>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" data-target="#report-permissions-tab" role="tab">
                                        <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                                        <h5 class="d-none d-md-block">Reports</h5>
                                    </a>
                                </li>
                            </ul>
                            }
                        </div>
                        <!-- accordion users-->
                        @if (!roleSelected && !loading) {
                        <users-roles></users-roles>
                        }
                        @if (roleSelected && (roleSelected.name != '')) {
                        <div class="tab-content">
                            <!-- section roles detail -->
                            <section class="tab-pane fade active show" id="role-permissions-tab" role="tabpanel">
                                <roles-detail [role]="roleSelected" [notParents]="['reports']"></roles-detail>
                            </section>

                            <section class="tab-pane fade" id="report-permissions-tab" role="tabpanel">
                                <roles-detail [role]="roleSelected" [parents]="['reports']"></roles-detail>
                            </section>
                        </div>
                        }
                        <!-- roles detail -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}
<!-- loading -->
<!-- loading -->
@if (loading ) {
<div class="content-page bg-gray d-flex justify-content-center align-items-center">
    <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
</div>
}
<!-- ============================================================== -->
<!-- End Page content -->
<!-- ============================================================== -->
<!-- modals section -->
<button id="delete-modal-btn" data-toggle="modal" data-target="#deleteRoleModal" class="d-none"></button>
<div class="modal fade" id="deleteRoleModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">{{words[language][ 'delete' ]}} {{roleTarget['name']}} {{words[language][ 'role' ]}}?</h4>
                <button type="button" class="close" data-dismiss="modal" id="closeModalDelete">×</button>
            </div>
            <div class="modal-body d-flex justify-content-center align-items-center flex-column">
                <span class="text-warning dripicons-warning display-3"></span>
                <h4 class="modal-title mt-2" id="mySmallModalLabel">{{ words[language][ 'deleteRole' ] }}</h4>
                <!-- button confirm -->
                <button class="btn btn-light mt-2" (click)="deleteRole()">{{ words[language][ 'continue' ] }}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<button id="edit-modal-btn" data-toggle="modal" data-target="#editRoleModal" class="d-none"></button>
<div class="modal fade" id="editRoleModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">{{editing ? words[language][ 'edit' ] : words[language]['add' ]}} {{words[language][ 'role' ]}}</h4>
                <button type="button" class="close" data-dismiss="modal" id="closeEditModal">×</button>
            </div>
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="information">
                        <div class="form-group">
                            <label for="name">{{words[language][ 'name' ]}}</label>
                            <input type="text" id="name" class="form-control form-control-sm" formControlName="name" maxlength="50" />
                        </div>
                        <div class="form-group">
                            <label for="type">{{words[language][ 'type' ]}}</label>
                            <select id="type" class="form-control form-control-sm" formControlName="type">
                                @for (type of roleTypes; track type) {
                                <option value="{{type}}">{{type | titlecase}}</option>
                                }
                            </select>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card-footer text-right">
                <button type="button" class="btn btn-link btn-sm" data-dismiss="modal"><span class="text-danger">cancel</span></button>
                <button type="submit" class="btn btn-primary" (click)="save($event)">Save</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
